import { Pipe, PipeTransform } from '@angular/core';
    @Pipe({
      name: 'mlstringToJson'
    })
    export class mlvisualizePipe implements PipeTransform {
      transform(value: string): any {
        let added_feature:string[]=[];
        try {
            const jsonObject = JSON.parse(JSON.stringify(value));
            added_feature.push(jsonObject["column_name"]);
            return added_feature
        
        } catch (error) {
          console.error('Error parsing JSON string:', error);
          return '';
        }
      }
    }